var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiplayerSupport1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175 122.299C174.627 124.347 174.366 126.421 173.857 128.432C170.427 141.729 162.324 151.041 149.71 156.467C147.97 157.211 146.379 157.149 144.64 156.467C129.664 150.47 119.499 135.695 119.387 119.592C119.337 112.962 119.362 106.332 119.387 99.7024C119.387 96.7972 121.052 94.9224 123.935 94.8976C130.808 94.8231 136.723 92.3276 142.154 88.2925C147.075 84.6299 147.311 84.6547 152.22 88.2677C156.694 91.5578 161.491 94.0037 167.071 94.6617C167.891 94.761 168.724 94.8604 169.544 94.8355C172.179 94.7486 174.068 95.7915 175.012 98.3243V122.311L175 122.299ZM145.323 120.772C143.993 119.282 142.838 117.904 141.595 116.6C139.93 114.862 137.27 114.738 135.518 116.252C133.691 117.829 133.442 120.486 135.07 122.411C137.345 125.08 139.656 127.724 142.03 130.307C143.894 132.343 146.752 132.368 148.604 130.307C152.195 126.334 155.725 122.286 159.242 118.251C160.224 117.122 160.596 115.781 160.199 114.303C159.751 112.677 158.732 111.584 157.079 111.15C155.29 110.678 153.799 111.212 152.593 112.553C150.195 115.234 147.821 117.941 145.323 120.772Z",
    fill: "url(#paint0_linear_106_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.504 142.524H114.528C88.4673 142.524 62.3943 142.424 36.3339 142.598C29.7846 142.635 24.9378 137.818 25 131.275C25.174 111.82 25.0621 92.3646 25.0621 72.9094C25.0621 72.3382 25.0621 71.7547 25.0621 71.0967H168.438V85.983C165.418 85.6726 162.647 84.7042 160.137 83.0405C158.384 81.8858 156.707 80.6194 154.979 79.44C149.971 75.9884 144.242 76.0257 139.271 79.5145C137.829 80.5201 136.413 81.563 134.971 82.5563C131.765 84.7787 128.223 85.9457 124.296 86.0823C115.795 86.3803 110.576 91.8059 110.563 100.286C110.563 106.282 110.601 112.279 110.563 118.276C110.501 126.47 112.278 134.218 116.019 141.506C116.143 141.754 116.268 142.027 116.491 142.511L116.504 142.524ZM64.0099 110.305C57.908 110.305 51.8185 110.305 45.7166 110.305C42.7465 110.305 40.7581 112.068 40.7332 114.663C40.7208 117.27 42.7216 119.071 45.6669 119.071C57.8086 119.071 69.9627 119.071 82.1044 119.071C85.0621 119.071 87.0878 117.283 87.1002 114.7C87.1127 112.118 85.0746 110.293 82.1417 110.293C76.0895 110.293 70.0497 110.293 63.9975 110.293L64.0099 110.305ZM73.8401 100.323C76.6736 100.323 79.507 100.348 82.3281 100.323C85.1118 100.298 87.1499 98.3737 87.1127 95.8658C87.0754 93.3703 85.1243 91.57 82.3654 91.5576C76.7978 91.5452 71.2427 91.5452 65.6752 91.5576C62.8169 91.5576 60.8285 93.3578 60.8161 95.903C60.8161 98.4234 62.8293 100.298 65.6379 100.323C68.372 100.348 71.106 100.323 73.8401 100.323ZM46.5741 91.4955C46.5741 91.4955 46.5741 91.5327 46.5741 91.5452C46.1392 91.5452 45.7042 91.5452 45.2568 91.5452C42.6595 91.6072 40.7581 93.4572 40.7456 95.903C40.7456 98.2868 42.5725 100.174 45.0828 100.311C46.1019 100.36 47.1334 100.373 48.14 100.311C50.4018 100.162 52.1417 98.4979 52.3281 96.3748C52.5269 94.1649 51.1599 92.1659 49.0348 91.6942C48.2394 91.5203 47.3943 91.57 46.5741 91.5203V91.4955Z",
    fill: "url(#paint1_linear_106_299)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0992 62.0948C25.0992 58.7426 24.9004 55.4649 25.1489 52.2244C25.5342 46.9353 30.0205 43.0244 35.4638 43.012C47.6676 42.9872 59.859 43.012 72.0628 43.012C100.46 43.012 128.856 43.012 157.266 43.012C164.387 43.012 168.562 47.1712 168.575 54.2481C168.575 56.8306 168.575 59.413 168.575 62.1072H25.0992V62.0948Z",
    fill: "url(#paint2_linear_106_299)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_299",
    x1: 147.185,
    y1: 85.5518,
    x2: 147.185,
    y2: 157.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_299",
    x1: 96.7188,
    y1: 71.0967,
    x2: 96.7188,
    y2: 142.598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_299",
    x1: 96.7994,
    y1: 43.001,
    x2: 96.7994,
    y2: 62.1072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 114,
    fill: "white",
    transform: "translate(25 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiplayerSupport1);
export default __webpack_public_path__ + "static/media/Multiplayer_Support-1.2976688a910a477d9d270b3747c70cd3.svg";
export { ForwardRef as ReactComponent };